/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TechKeyboardIcon16Light } from './TechKeyboardIcon16Light';
import { TechKeyboardIcon16Regular } from './TechKeyboardIcon16Regular';
import { TechKeyboardIcon16Solid } from './TechKeyboardIcon16Solid';
import { TechKeyboardIcon20Light } from './TechKeyboardIcon20Light';
import { TechKeyboardIcon20Regular } from './TechKeyboardIcon20Regular';
import { TechKeyboardIcon20Solid } from './TechKeyboardIcon20Solid';
import { TechKeyboardIcon24Regular } from './TechKeyboardIcon24Regular';
import { TechKeyboardIcon24Solid } from './TechKeyboardIcon24Solid';
import { TechKeyboardIcon32Regular } from './TechKeyboardIcon32Regular';
import { TechKeyboardIcon64Regular } from './TechKeyboardIcon64Regular';
var sizes = {
    16: {
        light: TechKeyboardIcon16Light,
        regular: TechKeyboardIcon16Regular,
        solid: TechKeyboardIcon16Solid,
    },
    20: {
        light: TechKeyboardIcon20Light,
        regular: TechKeyboardIcon20Regular,
        solid: TechKeyboardIcon20Solid,
    },
    24: {
        regular: TechKeyboardIcon24Regular,
        solid: TechKeyboardIcon24Solid,
    },
    32: {
        regular: TechKeyboardIcon32Regular,
    },
    64: {
        regular: TechKeyboardIcon64Regular,
    },
};
export var TechKeyboardIcon = forwardRef('TechKeyboardIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
